// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"458":"ffee39d0f8c1f26c","769":"60c6cb4d4540f15d"}[chunkId] + ".js";
};